/* eslint-disable no-control-regex */
/** 理赔类型 */
export const ClaimType = {
  Init: '',
  Damage: 'damage',
  Delay: 'delay',
  Loss: 'loss',
  RA: 'return',
};
// RA 险种类型
export const RAPolicyType = ['RA', 'GENTLY_RA'];

/** 支付方式 */
export const PaidMethod = {
  Tremendous: 'tremendous',
};

/** 邮箱地址 */
export const EmailAddress = {
  Seel: '17support@seel.com',
};

/** 输入框状态 */
export const InputStatus = {
  /** 初始化 */
  Init: 0,
  /** 修改过 */
  Changed: 1,
};

/** 允许上传文件的最大大小（单位：MB） */
export const MAX_UPLOAD_FILE_SIZE = 20;
/** 允许上传文件的最大数量 */
export const MAX_UPLOAD_FILE_NUM = 10;
/** 允许上传文件的类型 */
export const ALLOWED_UPLOAD_TYPE = ['.jpg', '.jpeg', '.png', '.tif', '.tiff', '.ico', '.bmp', '.webp', '.gif', '.zip'];

/** deliver 状态 */
export const ShipmentStatus = {
  Delivered: 'delivered',
};

export const regEmail = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/;

// review页面 是否勾选bp insurance的金额临界值 >=50 默认勾选
export const TOTAL_MONEY_LIMIT_FOR_CHECKED = 50;

export const TREMENDOUS_HOVER = 'You‘ll receive your payout in a virtual Visa card, which can be used to make purchases wherever Visa is accepted.';
